// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "cl-attr.legacy." + {"176":"vwo-integration","186":"link-enhancement","300":"position-tracking","328":"storage-manager"}[chunkId] + ".chunk.js";
};